module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "a11_fore"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_vm._v("FOREWORD")]), _vm._v(" "), _c('p', {
    staticClass: "imagesmmmm"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/lin2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chauthor"
  }, [_c('i', [_vm._v("Edward L. Bale, Jr.,"), _c('br'), _vm._v(" Colonel, U.S. Marine Corps, Retired")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This book deals with the employment of a green United States Marine Corps Medium Tank Company in the first amphibious assault on a heavily defended beach. I was fortunate to command this company as a young first lieutenant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For a number of years, I have had the privilege of knowing and providing information to the authors of this book. They have endeavored to clear the fog surrounding the employment of this tank company. In so doing, they have tapped the memory of known survivors as well as historical records and reports. Historical records, in this instance, are not what one would expect. The official records of the Marine Corps do not accurately reflect the role this company played during those seventy-six hours. Those records were compiled for the most part by commanders of infantry units. The Marine Corps was, and is today, an infantry oriented service. This is as it must be if the Corps is to serve the nation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A detailed report of the operation of this company was prepared aboard the USS "), _c('i', [_vm._v("Ashland")]), _vm._v(", LSD-1, en route from Tarawa to Hawaii and delivered to the commanding officer, Second Tank Battalion. Extracts from that report were included in the after action report of the Second Tank Battalion. Much of the detail was not included in the final report.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("It is safe to say that the experience of this company had a profound effect on the Marine Corps. All Marine Corps Tank Battalions were converted from light to medium tanks. Tank-infantry communications and\n")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("\ntactics were developed and joint training was accelerated. Deep water fording kits for installation on tanks were developed and provided for subsequent operations. The Marine Corps converted some light tanks from gun to flame throwing vehicles.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The assistance I have provided to the furtherance of this project is done so in memory of the marines of this company I had the privilege of commanding.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('i', [_vm._v("Houston, Texas, December 2014")])])])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9327a36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/11_fore.vue
// module id = 87
// module chunks = 0